import { createContext, useContext } from 'react';

export const YoutubeVideosMetadataContext = createContext({});

export const useYoutubeVideoMetadata = (videoId) => {
  const videosMetadata = useContext(YoutubeVideosMetadataContext);

  return videosMetadata[videoId];
};
